import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import shiftService from '../services/shiftService';
import ShiftAnalyzer from '../components/ShiftAnalyzer';

function ShiftView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [shift, setShift] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadShift();
  }, [id]);

  const loadShift = async () => {
    try {
      const response = await shiftService.getShift(id);
      setShift(response.data);
    } catch (err) {
      setError('Failed to load shift data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return (
      <div className="app-container">
        <div className="container">
          <div className="error-message">{error}</div>
          <button onClick={() => navigate('/shifts')} className="btn btn-secondary">
            Back to Shifts
          </button>
        </div>
      </div>
    );
  }

  const staffGroups = shift?.processedData?.staffGroups || [];

  return (
    <div className="app-container">
      <div className="container">
        <div className="page-header">
          <h1>Shift Data Details</h1>
          <p>File: {shift?.fileName}</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-label">Staff Count</div>
            <div className="stat-value">{shift?.staffCount || 0}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Total Hours</div>
            <div className="stat-value">{shift?.totalHours?.toFixed(1) || 0}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Overtime Hours</div>
            <div className="stat-value">{shift?.totalOvertimeHours?.toFixed(1) || 0}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Night Work Hours</div>
            <div className="stat-value">{shift?.totalNightWorkHours?.toFixed(1) || 0}</div>
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <button onClick={() => navigate('/shifts')} className="btn btn-secondary">
            ← Back to Shifts
          </button>
        </div>

        {staffGroups.length === 0 ? (
          <div className="card">
            <p style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
              No staff data available
            </p>
          </div>
        ) : (
          <ShiftAnalyzer shiftData={shift} />
        )}
      </div>
    </div>
  );
}

export default ShiftView;
